/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the GC content and base composition of a DNA or RNA sequence.`)
};

const es_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el contenido GC y la composición de bases de una secuencia de ADN o ARN.`)
};

const de_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie den GC-Gehalt und die Basenzusammensetzung einer DNA- oder RNA-Sequenz.`)
};

const nl_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken het GC-gehalte en de basensamenstelling van een DNA- of RNA-sequentie.`)
};

const fr_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez le contenu GC et la composition en bases d'une séquence d'ADN ou d'ARN.`)
};

const it_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il contenuto GC e la composizione in basi di una sequenza di DNA o RNA.`)
};

const pt_br2_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o conteúdo GC e a composição de bases de uma sequência de DNA ou RNA.`)
};

const pt_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o conteúdo em GC e a composição de bases de uma sequência de ADN ou ARN.`)
};

const ja_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAまたはRNA配列のGC含量と塩基組成を計算します。`)
};

const zh_gc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算 DNA 或 RNA 序列的 GC 含量和碱基组成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_tool_description", locale)
	if (locale === "en") return en_gc_tool_description(inputs)
	if (locale === "es") return es_gc_tool_description(inputs)
	if (locale === "de") return de_gc_tool_description(inputs)
	if (locale === "nl") return nl_gc_tool_description(inputs)
	if (locale === "fr") return fr_gc_tool_description(inputs)
	if (locale === "it") return it_gc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_gc_tool_description(inputs)
	if (locale === "pt") return pt_gc_tool_description(inputs)
	if (locale === "ja") return ja_gc_tool_description(inputs)
	return zh_gc_tool_description(inputs)
};